export interface StaffCostEntry {
  headCount?: number;
  headCountAvgAmount?: number;
  name?: string;
  personTime?: number;
  personTimeAvgAmount?: number;
  totalRetail?: number;
}

export function fromJson(json: any): StaffCostEntry {
  return {
    headCount: json.headCount,
    headCountAvgAmount: json.headCountAvgAmount,
    name: json.name,
    personTime: json.personTime,
    personTimeAvgAmount: json.personTimeAvgAmount,
    totalRetail: json.totalRetail,
  };
}
